// §9.17/D124 — die LITERAL gleiche ops.py der GPU-Runtime als zweite Runtime (Pyodide).
// `?raw` über die Monorepo-Grenze (vite.config: server.fs.allow) ⇒ EINE Algorithmus-
// Quelle, kein Port, kein Drift: jede ops.py-Änderung (D116/D120/…) ist hier sofort wirksam.
import opsSource from "../../../gpu-runtime/ops.py?raw";

export { opsSource };

let hashPromise: Promise<string> | null = null;

/** sha256-hex über den ops.py-Quelltext — Provenance des Edit-Assets (EditRequest.opsHash). */
export function getOpsHash(): Promise<string> {
  hashPromise ??= (async () => {
    const bytes = new TextEncoder().encode(opsSource);
    const digest = await crypto.subtle.digest("SHA-256", bytes);
    return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, "0")).join("");
  })();
  return hashPromise;
}
